// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.scss\"","royalColor":"#276DF1","smallWidth":"768px","alert":"Alert_alert__3M98a"};